const _ = require('lodash');
const moment = require('moment');
const defaultState = {
    ci: [],
    ciDetail: {},
    loading: false,
    loadingHist: false,
    errors:{},
    lastFiltersCI: '',
    ciHist:[]
}
  
export default (state=defaultState, action={}) => {
    switch (action.type) {
        case 'FETCH_CI_FULFILLED': {
            let arrayMain=[];
            let newItem = {};
            let indipsMode = '';

            if(Array.isArray(action.payload.data)){
                action.payload.data.forEach((element,index) => {
                    newItem = {};
                    newItem = element;//limpa para criar um novo
                    indipsMode = element.FLAG_G === 1 ? 'G ' : '';
                    indipsMode = element.FLAG_GT === 1 ? indipsMode + 'GT ' : indipsMode + '';
                    indipsMode = element.FLAG_GC === 1 ? indipsMode + 'CG' : indipsMode + '';
                    indipsMode = element.FLAG_B === 1 ? indipsMode + 'B ' : indipsMode + '';
                    indipsMode = element.FLAG_BT === 1 ? indipsMode + 'BT ' : indipsMode + '';
                    indipsMode = element.FLAG_BC === 1 ? indipsMode + 'CB' : indipsMode + '';
                    newItem["indispMode"] = indipsMode;
                    newItem["BEGIN_DATETIME_LOCAL"] = moment.utc(element.BEGIN_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm');
                    newItem["END_DATETIME_LOCAL"] = moment.utc(element.END_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm');

                    //fazer set de state destes valores como auxiliares para criar valdiações
                    arrayMain.push(newItem);
                });
            }else{
                console.log('FETCH_CI_FULFILLED error: ');
                console.dir(action.payload.data);
            }
            return {
                ...state,
                ci: arrayMain,
                loading: false,
                errors: {}
            }
      }
  
      case 'FETCH_CI_PENDING': {
        return {
          ...state,
          loading: true,
          errors: {}
        }
      }
  
      case 'FETCH_CI_REJECTED': {
        return {
          ...state,
          loading: false,
          errors: { global: action.payload.message }
        }
      }
  
      case 'FETCH_CI_DETAIL_FULFILLED': {

        const id = action.payload.data[0].ID;
        const status = action.payload.data[0].STATUS;
        const idFI = action.payload.data[0].ID_FI;

        return {
          ...state,
          ciDetail: action.payload.data[0],
          ci: state.ci.map(item => item.ID === id ? {...item, STATUS: status, ID_FI: idFI} : item),
          errors: {},
          loadingHist: false
        }
      }

      case 'FETCH_CI_DETAIL_PENDING': {
        return {
          ...state,
          loadingHist: true,
          ciDetail: {},
          errors: {}
        }
      }
      
      case 'FETCH_CI_DETAIL_REJECTED': {
        return {
          ...state,
          loadingHist: false,
          errors: { global: action.payload.message }
        }
      }      

      case 'LASTFILTER_CI': {      
        return {
          ...state,
          lastFiltersCI: action.payload
        }
      }

      case 'FETCH_CI_HISTORY_FULFILLED': {
        let arrayMain=[];
        let newItem = {};
        let indipsMode = '';
        
        if(Array.isArray(action.payload.data)){
            action.payload.data.forEach((element,index) => {
            newItem = {};
            newItem = element;//limpa para criar um novo
            indipsMode = element.FLAG_G === 1 ? 'G ' : '';
            indipsMode = element.FLAG_GT === 1 ? indipsMode + 'GT ' : indipsMode + '';
            indipsMode = element.FLAG_GC === 1 ? indipsMode + 'CG' : indipsMode + '';
            indipsMode = element.FLAG_B === 1 ? indipsMode + 'B ' : indipsMode + '';
            indipsMode = element.FLAG_BT === 1 ? indipsMode + 'BT ' : indipsMode + '';
            indipsMode = element.FLAG_BC === 1 ? indipsMode + 'CB' : indipsMode + '';
            newItem["indispMode"] = indipsMode;

            //fazer set de state destes valores como auxiliares para criar valdiações
            arrayMain.push(newItem);
            });
        }else{
            console.log('FETCH_CI_HISTORY_FULFILLED error: ');
            console.dir(action.payload.data);
        }
        return {
          ...state,
          ciHist: arrayMain,
          loadingHist: false,
          errors: {}
        }
      }
  
      case 'FETCH_CI_HISTORY_PENDING': {
        return {
          ...state,
          loadingHist: true,
          errors: {}
        }
      }
  
      case 'FETCH_CI_HISTORY_REJECTED': {
        return {
          ...state,
          loadingHist: false,
          errors: { global: action.payload.message }
        }
      }

      case 'REFRESH_CI_LIST': {      
        const id = action.payload['rejectCIId'];
        const prevStatus = action.payload['rejectCIStatus'];
        let auxDetail = _.cloneDeep(state.ciDetail);
        auxDetail['STATUS'] = prevStatus;
        return {
          ...state,
          ci: state.ci.map(item => item.ID === id ? {...item, STATUS: prevStatus} : item),
          ciDetail: auxDetail
        }
      }

      //cases de refresh do state com base em sockets emitidos pelo server
      case 'DELETE_CI_FULFILLED': {
        const id = action.id;
        return {
            ...state,
            ci: state.ci.map(item => item.ID === id ? {...item, STATUS: 'Eliminada'} : item)
        }
      }

      case 'EDIT_CI_FULFILLED': {

        const id = action.editedRecord.ID;
        const auxEditedRecord = action.editedRecord;
        let indipsMode = auxEditedRecord.FLAG_G === 1 ? 'G ' : '';
        indipsMode = auxEditedRecord.FLAG_GT === 1 ? indipsMode + 'GT ' : indipsMode + '';
        indipsMode = auxEditedRecord.FLAG_GC === 1 ? indipsMode + 'CG' : indipsMode + '';
        indipsMode = auxEditedRecord.FLAG_B === 1 ? indipsMode + 'B ' : indipsMode + '';
        indipsMode = auxEditedRecord.FLAG_BT === 1 ? indipsMode + 'BT ' : indipsMode + '';
        indipsMode = auxEditedRecord.FLAG_BC === 1 ? indipsMode + 'CB' : indipsMode + '';
        auxEditedRecord["indispMode"] = indipsMode;        
        return {
            ...state,
            ci: state.ci.map(item => item.ID === id 
              ? auxEditedRecord 
              : item
              )
        }
      }

      default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/ci-reducer.js